import noResult from '@/assets/no-result.svg';
import { ptBrCommon } from '@/lib/pt-br/messages';
import { Image } from '@/components/ui/image';
import Link from '@/components/ui/link';
import { Routes } from '@/config/routes';

type NotFoundProps = {
  title?: string;
  subTitle?: string;
  image?: string;
  link?: string;
  linkTitle?: string;
};

const NotFound: React.FC<NotFoundProps> = ({
  title = '404-heading',
  subTitle = '404-sub-heading',
  image = noResult,
  link = Routes.home,
  linkTitle = '404-back-home',
}) => {
return (
    <div className="grid min-h-screen place-items-center p-4 sm:p-8">
      <div className="text-center">
        {title ? (
          <p className="2xl: mb-4 text-sm uppercase tracking-widest text-body-dark sm:mb-5">
            {ptBrCommon(title)}
          </p>
        ) : (
          ''
        )}
        {subTitle ? (
          <h1 className="mb-5 text-2xl font-bold leading-normal text-bolder sm:text-3xl">
            {ptBrCommon(subTitle)}
          </h1>
        ) : (
          ''
        )}
        {image ? (
          <div className="mx-auto mb-11 w-96">
            <Image src={image} alt={ptBrCommon(title)} unoptimized={true} />
          </div>
        ) : (
          ''
        )}
        {link ? (
          <Link
            href={link}
            className="inline-flex items-center text-bolder underline hover:text-body-dark hover:no-underline focus:outline-none sm:text-base"
          >
            {ptBrCommon(linkTitle)}
          </Link>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default NotFound;
